import { render, staticRenderFns } from "./WhatsappPersonal.vue?vue&type=template&id=1a7117ac"
import script from "./WhatsappPersonal.vue?vue&type=script&lang=js"
export * from "./WhatsappPersonal.vue?vue&type=script&lang=js"
import style0 from "./WhatsappPersonal.vue?vue&type=style&index=0&id=1a7117ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports